import { Component } from '@angular/core';
import { View } from 'src/graphics/view';

@Component({
    selector: 'app-canvas',
    template: '<app-context-menu></app-context-menu>',
    styleUrls: ['./canvas.component.scss'],
    standalone: false
})

export class CanvasComponent {
    ngAfterViewInit() {
        const canvas = document.querySelector('app-canvas') as Element;
        canvas.appendChild(View.app.canvas);
    }
}
